import { Component, computed, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { RippleModule } from 'primeng/ripple';
import { AiSessionCoordinator } from '../ai-session-coordinator';
import { AiSessionSettingsService } from '../ai-session-settings.service';
import { AiSessionDialogComponent } from './ai-session-dialog.component';

@Component({
  selector: 'lib-ai-session-setting',
  standalone: true,
  imports: [RippleModule, TranslateModule],
  template: `
    <div class="settings-item" pRipple (click)="onClick()" (keydown.enter)="onClick()" role="button" tabindex="0">
      <div>
        <span class="mr-2">🛰️</span>
        {{ 'screens.ai_session.titles.section' | translate }}
        <p>
          @if (configuredHostname(); as hostname) {
            {{ hostname }}
          } @else {
            {{ 'screens.ai_session.labels.not_configured' | translate }}
          }
        </p>
      </div>
    </div>
  `,
})
export class AiSessionSettingComponent {
  private readonly dialogService = inject(DialogService);
  private readonly translate = inject(TranslateService);
  private readonly coordinator = inject(AiSessionCoordinator);
  readonly settings = inject(AiSessionSettingsService);

  readonly configuredHostname = computed(() => {
    const value = this.settings.relayUrl();
    if (!value) return '';
    try {
      return new URL(value).hostname;
    } catch (error) {
      console.warn('Failed to parse relay URL', error);
      return value;
    }
  });

  onClick(): void {
    const ref = this.dialogService.open(AiSessionDialogComponent, {
      header: this.translate.instant('screens.ai_session.titles.section'),
      styleClass: 'p-dialog-form p-dialog-maximized',
      modal: true,
      closable: true,
      pt: {
        header: { class: '[@media(max-height:300px)]:hidden' },
      },
    });
    ref?.onClose.subscribe(() => {
      void this.coordinator.stop();
    });
  }
}
